import { useContext } from "react"
import { useEnrollments } from "utils/hooks/useEnrollments"

import { context } from "./context"

export const useCpat = () => {
  const { attempt, reports } = useContext(context)
  const {
    cpat: { latestCPAT },
  } = useEnrollments()

  return {
    attempt,
    reports,
    hasCompletedCpat: latestCPAT?.progress === 100,
  }
}
